import { useEffect, useState } from 'react';
import './RotateDeviceOverlay.css';



export default function RotateDeviceOverlay() {
    const [showRotateOverlay, setShowRotateOverlay] = useState(false);
  useEffect(() => {
    function checkOrientation() {
      const isMobile = typeof window !== 'undefined' && /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
      const isLandscape = window.matchMedia('(orientation: landscape)').matches;
      setShowRotateOverlay(isMobile && isLandscape);
    }
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);
    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);
  return showRotateOverlay ? (
    <div className="rotate-device-overlay">
      <h2 className="rotate-device-text">Please rotate your device to portrait mode</h2>
    </div>
  ) : null;
}
